import { computed } from "vue";

import { $t } from "@/i18n";
import { Routes } from "@/router";
import type { NavNode } from "@/utils/navUtils";

export function useHomeNav() {
  const nav = computed<NavNode>(() => ({
    label: $t("common.label.home"),
    icon: "phosphor/house",
    layoutStoreKey: "home",
    route: { name: Routes.HOME },
  }));

  return nav;
}
